module.exports = __webpack_public_path__ + "img/EMC2-alt.82360193.svg";